import { axiosWrapperService } from "@/services/auth/axios-wrapper-service";
import { formatErrorMessage } from "@/utils/messageFormatter";

const state = () => {
  return {
    applicationId: 0,
    isBusy: false,
    auditLogs: ""
  };
};

const getters = {
  isBusy: state => state.isBusy,
  auditLogs: state => state.auditLogs
};

const mutations = {
  setApplicationId(state, applicationId) {
    state.applicationId = applicationId;
  },
  setIsBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
  setAuditLogs(state, auditLogs) {
    state.auditLogs = auditLogs;
  }
};

const actions = {
  getAuditLogs: async ({ dispatch, state, commit }) => {
    commit("setIsBusy", true);
    axiosWrapperService
      .axiosGet(`/applications/${state.applicationId}/audit-logs`)
      .then(response => {
        //Fetching and setting logs summary
        commit("setAuditLogs", response.data?.data ?? "");
      })
      .catch(error => {
        dispatch(
          "globalToastMessage/showSimpleToast",
          { message: formatErrorMessage(error), type: "error" },
          { root: true }
        );
      })
      .finally(() => {
        commit("setIsBusy", false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
